export type AnalysisGuardDeps = {
  isAuthenticated: () => boolean;
  getUserId: () => number | null;
  getUserBusiness: (userId: number) => Promise<{ success: boolean; business: { id: number } | null }>;
  getBrandByBusinessId: (businessId: number) => Promise<{ success: boolean; brand: { id: number } | null }>;
  getRealBrandAnalysis: (brandId: number) => Promise<{ success: boolean; ready?: boolean; analysis?: unknown }>;
  fetchUserProfile?: () => Promise<void>;
  hasUserProfile: () => boolean;
  getBusinessId?: () => number | null;
};

export async function checkUserHasRealAnalysis(deps: AnalysisGuardDeps): Promise<boolean> {
  try {
    if (!deps.hasUserProfile()) {
      await deps.fetchUserProfile?.();
      if (!deps.hasUserProfile()) {
        return false;
      }
    }

    if (!deps.isAuthenticated()) {
      return false;
    }

    let businessId = deps.getBusinessId?.() ?? null;

    if (!businessId) {
      const userId = deps.getUserId();
      if (!userId) {
        return false;
      }

      const businessResponse = await deps.getUserBusiness(userId);
      if (!businessResponse.success || !businessResponse.business) {
        return false;
      }
      businessId = businessResponse.business.id;
    }

    const brandResponse = await deps.getBrandByBusinessId(businessId);
    if (!brandResponse.success || !brandResponse.brand) {
      return false;
    }

    const analysisResponse = await deps.getRealBrandAnalysis(brandResponse.brand.id);
    return !!(analysisResponse.success && analysisResponse.ready && analysisResponse.analysis);
  } catch {
    return false;
  }
}
